import toast from "react-hot-toast";
import api from "../Crypto/axios.js";

export const ADD_RATING = "ADD_RATING";
export const GET_RATING = "GET_RATING";

const initialState = {
    ratings: [],
    productRatings : []
  };

  const ratingReducer = (state = initialState, action) => {
    switch (action.type) {
      case ADD_RATING:
        return {
          ...state,
          ratings: action.payload,
        };
        case GET_RATING:
          return {
            ...state,
            productRatings: action.payload,
          };
      default:
        return state;
    }
  };

  export default ratingReducer;
  
  export const addRating = (data) => ({
    type: ADD_RATING,
    payload: data,
  });

  export const getRating = (data) => ({
    type: GET_RATING,
    payload: data,
  });
  
  export const addRatingForProduct = (product_id, data) => {
    return async (dispatch) => {
      const promise = (async () => {
        try {
          const response = await api.post(
            `/nrcb/ecom/rating/${product_id}`,
            data
          );
          if (!response) {
            const errorData = response;
            console.error('Server error:', errorData);
            const errorMessage = errorData.message || 'Failed to add rating';
            throw new Error(errorMessage);
          }
          const val = response;
          dispatch(addRating(val));
          return val;
        } catch (error) {
          console.error('Error in adding rating:', error);
          throw new Error(error.message || 'Failed to add rating');
        }
      })();
      toast.promise(promise, {
        loading: 'Submitting rating...',
        success: 'Rating added successfully',
        error: (error) => error.message || 'Failed to rate this product',
      });

      return promise;
    };
  };

  export const getProductRating = (productId) => {
    return async (dispatch) => {
      try {
        const response = await api.get(`/nrcb/ecom/get/rating/${productId}`);
        if (!response) {
          throw new Error('Failed to fetch product rating');
        }
        dispatch(getRating(response));
        return response;
      } catch (error) {
        console.error('Failed to fetch product rating:', error);
        throw error;
      }
    };
  };

  
  
  